import jamieImgSrc from '@assets/images/team-jamie.jpg';
import mariaImgSrc from '@assets/images/team-maria.jpg';
import sophieImgSrc from '@assets/images/team-sophie.jpg';
import { AvatarProps, ButtonLink, cn, RiCalendarEventLine } from 'component-library';
import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { AvatarGroup } from '@/components';
import { BUYER_CALENDLY_LINK } from '@/config/constants';
import { useScreenSize } from '@/hooks/useScreenSize';

import { Card } from '../card/Card';

export const ScheduleMeeting: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...delegated }) => {
  const { t } = useTranslation();
  const isLargeScreen = useScreenSize() === 'large';

  const avatars: AvatarProps[] = [
    {
      image: sophieImgSrc,
      name: 'Sophie van Berchem',
    },
    {
      image: mariaImgSrc,
      name: 'Maria Koppatz',
    },
    {
      image: jamieImgSrc,
      name: 'Jamie Batho',
    },
  ];

  const styles = cn('items-start', className);

  return (
    <Card
      label={t('buyer.portfolio.scheduleMeeting.title')}
      data-testid='portfolio-schedule-meeting'
      className={styles}
      {...delegated}
    >
      <div className='flex max-w-xl flex-col gap-4 lg:flex-row'>
        <AvatarGroup items={avatars} />
        <span className='typography-body1 text-text-secondary'>{t('buyer.portfolio.scheduleMeeting.subtitle')}</span>
      </div>
      <ButtonLink
        to={BUYER_CALENDLY_LINK}
        target='_blank'
        rel='noreferrer'
        leftAdornment={<RiCalendarEventLine className='h-5 w-5' />}
      >
        {isLargeScreen
          ? t('buyer.portfolio.scheduleMeeting.buttonLabel')
          : t('buyer.portfolio.scheduleMeeting.buttonLabelShort')}
      </ButtonLink>
    </Card>
  );
};
